import { InboxApi } from 'conversations/api'
import Bootstrap from 'shared/typings/bootstrap'

export const fetchBootstrap = async (): Promise<Bootstrap> => {
  const res = await InboxApi.get('/bootstrap')
  return res.data
}
